import { DBSchema, IDBPDatabase, openDB } from 'idb';

const DB_VERSION = 1;

export interface DirectoryDb extends DBSchema {
    'file-handles': {
        value: FileSystemFileHandle | FileSystemDirectoryHandle;
        key: string;
    };
}

export async function getDirectoryDb(): Promise<IDBPDatabase<DirectoryDb>> {
    return await openDB<DirectoryDb>('fe-directories', DB_VERSION, {
        upgrade(database) {
            if (!database.objectStoreNames.contains('file-handles')) {
                database.createObjectStore('file-handles');
            }
        }
    });
}
